import { Space, Row, Dropdown } from "antd";
import HideOnMobile from "./hideOnMobile";
import { MoreVert } from "@mui/icons-material";


function GenericDropdown(props) {

    return (
        (props.dropdownItems.filter(function (element) { return element !== undefined }).length > 0) &&
        <HideOnMobile>
            <Dropdown
                overlay={
                    <Space
                        style={{
                            backgroundColor: "white",
                            padding: "10px",
                            overflow: "auto",
                            maxHeight: "300px",
                        }}
                        direction="vertical"
                    >
                        {props.dropdownItems
                            .filter((element) => element !== undefined)
                            .map((item, index) => (
                                <Row key={index}>{item}</Row>
                            ))}
                    </Space>
                }
                placement={props.placement || "bottomRight"}
                trigger={props.trigger || "hover"}
                arrow
            >
                <button
                    style={{
                        all: "unset",             // remove all default button styles
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "32px",
                        height: "32px",
                        padding: 0,
                    }}
                    onClick={(e) => e.preventDefault()}
                >
                    <MoreVert fontSize="small" />
                </button>
            </Dropdown>
        </HideOnMobile>
    )
}


export default GenericDropdown;